import React from "react";
import { ISearchField, ISearchProp } from "../Types";
import { Select } from "antd";

type PropType = ISearchProp & ISearchField;
export const SearchSelect = (props: PropType) => {
    return <Select
        allowClear
        mode={props.mode}
        className="ant-select-round"
        showSearch={true}
        value={props.searchValues?.[props.fieldName]}
        optionFilterProp="label"
        placeholder={props.placeholder}
        onChange={(value, option) => {
            props.onChange?.({ [props.fieldName]: value }, option)
            if (props.triggerSearch) props.handleSearch?.({ [props.fieldName]: value }, option);
        }}
        disabled={props.disabled}
        options={props.options}
    />
}